import { Base } from "../base";
import { isObject } from "@pineapplelab/util";
// import { KeyOfByType } from "src/app/types/key-of-by-type";
import firebase from "firebase/compat/app";
import { serverTimestamp } from "firebase/firestore";

export abstract class FBase<T=any> extends Base {

  private __createdAt = serverTimestamp() as firebase.firestore.Timestamp;
  private __updatedAt = serverTimestamp() as firebase.firestore.Timestamp;
//   createdAt: Object = null;
  deletedAt: Object = null;
  createdBy: string = null;
  updatedBy: string = null;
  deletedBy: string = null;
  isDeleted: boolean = false;
  isHidden: boolean = false;
  id: string = null;

  set createdAt(timestamp: any) {
    this.__createdAt = timestamp;
  }

  get createdAt() {
    if (this.__createdAt) {
      return null;
    }
    return this.__createdAt;
  }

  set updatedAt(timestamp: any) {
    this.__updatedAt = timestamp;
  }

  get updatedAt() {
    return this.__updatedAt;
  }



  /**
  * Keep in mind that the class properties initialization will overwrite all values set here!
  *
  * Call fromJson() method from your subclass constructor instead.
  *
  * Example:
  * ```typescript
    export class User extends FBase {

      firstName: string = null;
      ....

      constructor(json?: { [key: string]: any }) {
        super(); // don't pass json here if you'll call this.fromJson(json)

        if (isObject(json)) {
          this.fromJson(json);
        }
      }

    }
  * ```
  *
  */
  constructor(json?: { [key: string]: any }) {
    super();
    if (isObject(json)) {
      this.fromJson(json);
    }

  }

  override toJson(camelCase = false, onlyFields: string[] = null, onlyFieldsAreRemovedInTheJson = false) {
    const json = super.toJson(camelCase, onlyFields, onlyFieldsAreRemovedInTheJson);
    // if (this.__createdAt instanceof firebase.firestore) {
    //   json.created_at = this.__createdAt;
    // } else {
    // //   json.updated_at = firebase.firestore.serverTimestamp();
    // }
    if (!json.is_deleted) {
      json.is_deleted = false;
    }
    return json;
  }

//   setServerTimestamp(field: KeyOfByType<T, firebase.firestore.Timestamp>) {
// 	(this as any)[field] = firebase.firestore.FieldValue.serverTimestamp() as firebase.firestore.Timestamp;
//   }

}
